// extracted by mini-css-extract-plugin
export default {"messageContainer":"oEGUKwCFvhxcQOh_XqhW","checkInbox":"HsK2pJv0Pcef7LImDnfR"};